









































import { Alert } from "@/models/general";
import { LayoutModule } from "@/store/layout";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class GlobalAlerts extends Vue {
  hideAlerts = false;

  get alerts(): Alert[] {
    this.hideAlerts = false;
    setTimeout(() => {
      this.hideAlerts = true;
    }, 20000);
    return LayoutModule.getAlerts;
  }

  goToCampaign(campaign_id: string, line_item_id: string): void {
    let routeData = this.$router.resolve({
      name: "edit-campaign",
      params: { id: String(campaign_id) },
      query: { highlight_lineitem: line_item_id },
    });
    window.open(routeData.href, "_blank");
  }
}
